import { Component } from '@angular/core';
import { AppService } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'portal-beneficiario';

  constructor(private themeService: AppService) {
    this.themeService.loadThemeColors(sessionStorage.getItem('theme'));
  }
}
